import React, { useState } from 'react';
import css from './Sections.module.css';

import { Tabs, Button, Collapse, Tag } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import TalentImg from '../../../../assets/talent.png';
import WorkImg from '../../../../assets/work.png';
import PartnersImg from '../../../../assets/partners.png';
import RPFsImg from '../../../../assets/rfps.png';
import { createResourceLocatorString } from '../../../../util/routes';
import fieldOptions from '../../../../config/fieldOptions';

const Talent = (props) => {
  const { redirectToSearchPage } = props;

  const [selectedServiceDomain, setSelectedServiceDomain] = useState(null);

  // Get service domains from fieldOptions
  const serviceDomains = fieldOptions.serviceDomainsOptions || [];

  // Get technologies for the selected service domain
  const getTechnologies = (domainKey) => {
    return fieldOptions.serviceDomainTechnologyMapping[domainKey] || [];
  };

  const handleServiceDomainClick = (domainKey) => {
    setSelectedServiceDomain(domainKey);
  };

  const handleTechnologyClick = (technology) => {
    // Redirect to search page with the technology as filter
    redirectToSearchPage('candidate', technology);
  };

  const handleBackToServiceDomains = () => {
    setSelectedServiceDomain(null);
  };

  // Get selected service domain label
  const getSelectedDomainLabel = () => {
    const domain = serviceDomains.find(d => d.key === selectedServiceDomain);
    // return domain ? domain.subdomain : '';
    return domain ? domain.label : '';
  };

  return (
    <>
      <div className={css.tabContent}>
        <div className={css.tabHeading}>
          <h3>Talent</h3>
        </div>
        <div className={css.cardScroll}>
          {!selectedServiceDomain ? (
            <div className={css.tagsContainer}>
              <h5>Select a Service Domain:</h5>
              <div className={css.tagsWrapper}>
                {serviceDomains.map(domain => (
                  domain?.subdomain && (
                    <Tag
                      key={domain.key}
                      color="blue"
                      className={css.serviceTag}
                      onClick={() => handleServiceDomainClick(domain.key)}
                    >
                      {/* {domain.subdomain} */}
                      {domain.label}
                    </Tag>
                  )
                ))}
              </div>
            </div>
          ) : (
            <div className={css.tagsContainer}>
              <div className={css.tagsContainerTitle}>
                <Button
                  color="default"
                  variant="filled"
                  type="link"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleBackToServiceDomains}
                >
                  Back
                </Button>
                <div>
                  <h4>{getSelectedDomainLabel()}</h4>
                </div>
              </div>
              <div className={css.tagsWrapper}>
                  <p>Select a Technology:</p>
                {getTechnologies(selectedServiceDomain).map((tech, index) => (
                  <Tag
                    key={index}
                    color="green"
                    className={css.technologyTag}
                    onClick={() => handleTechnologyClick(tech)}
                  >
                    {tech}
                  </Tag>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const Work = (props) => {
  const { redirectToSearchPage } = props;

  const [selectedServiceDomain, setSelectedServiceDomain] = useState(null);

  // Get service domains from fieldOptions
  const serviceDomains = fieldOptions.serviceDomainsOptions || [];

  // Get technologies for the selected service domain
  const getTechnologies = (domainKey) => {
    return fieldOptions.serviceDomainTechnologyMapping[domainKey] || [];
  };

  const handleServiceDomainClick = (domainKey) => {
    setSelectedServiceDomain(domainKey);
  };

  const handleTechnologyClick = (technology) => {
    // Redirect to search page with the technology as filter
    redirectToSearchPage('job_listing', technology);
  };

  const handleBackToServiceDomains = () => {
    setSelectedServiceDomain(null);
  };

  // Get selected service domain label
  const getSelectedDomainLabel = () => {
    const domain = serviceDomains.find(d => d.key === selectedServiceDomain);
    // return domain ? domain.subdomain : '';
    return domain ? domain.label : '';
  };

  return (
    <>
      <div className={css.tabContent}>
        <div className={css.tabHeading}>
          <h3>Work</h3>
        </div>
        <div className={css.cardScroll}>
          {!selectedServiceDomain ? (
            <div className={css.tagsContainer}>
              <h4>Select a Service Domain:</h4>
              <div className={css.tagsWrapper}>
                {serviceDomains.map(domain => (
                  domain?.subdomain && (
                    <Tag
                      key={domain.key}
                      color="blue"
                      className={css.serviceTag}
                      onClick={() => handleServiceDomainClick(domain.key)}
                      style={{ cursor: 'pointer', margin: '8px', padding: '8px 12px', fontSize: '14px' }}
                    >
                      {/* {domain.subdomain} */}
                      {domain.label}
                    </Tag>
                  )
                ))}
              </div>
            </div>
          ) : (
            <div className={css.tagsContainer}>
              <div style={{ marginBottom: '16px' }}>
                <Button
                  type="link"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleBackToServiceDomains}
                  style={{ padding: 0, marginBottom: '8px' }}
                >
                  Back
                </Button>
                <h4 style={{ marginBottom: '8px' }}>{getSelectedDomainLabel()}</h4>
                <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>Select a Technology:</p>
              </div>
              <div className={css.tagsWrapper}>
                {getTechnologies(selectedServiceDomain).map((tech, index) => (
                  <Tag
                    key={index}
                    color="green"
                    className={css.technologyTag}
                    onClick={() => handleTechnologyClick(tech)}
                    style={{ cursor: 'pointer', margin: '8px', padding: '8px 12px', fontSize: '14px' }}
                  >
                    {tech}
                  </Tag>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const Partners = (props) => {
  const { redirectToSearchPage } = props;

  const [selectedServiceDomain, setSelectedServiceDomain] = useState(null);

  // Get service domains from fieldOptions
  const serviceDomains = fieldOptions.serviceDomainsOptions || [];

  // Get technologies for the selected service domain
  const getTechnologies = (domainKey) => {
    return fieldOptions.serviceDomainTechnologyMapping[domainKey] || [];
  };

  const handleServiceDomainClick = (domainKey) => {
    setSelectedServiceDomain(domainKey);
  };

  const handleTechnologyClick = (technology) => {
    // Redirect to search page with the technology as filter
    redirectToSearchPage('agency', technology);
  };

  const handleBackToServiceDomains = () => {
    setSelectedServiceDomain(null);
  };

  // Get selected service domain label
  const getSelectedDomainLabel = () => {
    const domain = serviceDomains.find(d => d.key === selectedServiceDomain);
    // return domain ? domain.subdomain : '';
    return domain ? domain.label : '';
  };  

  return (
    <>
      <div className={css.tabContent}>
        <div className={css.tabHeading}>
          <h3>Suppliers</h3>
        </div>
        <div className={css.cardScroll}>
          {!selectedServiceDomain ? (
            <div className={css.tagsContainer}>
              <h4>Select a Service Domain:</h4>
              <div className={css.tagsWrapper}>
                {serviceDomains.map(domain => (
                  domain?.subdomain && (
                    <Tag
                      key={domain.key}
                      color="blue"
                      className={css.serviceTag}
                      onClick={() => handleServiceDomainClick(domain.key)}
                      style={{ cursor: 'pointer', margin: '8px', padding: '8px 12px', fontSize: '14px' }}
                    >
                      {/* {domain.subdomain} */}
                      {domain.label}
                    </Tag>
                  )
                ))}
              </div>
            </div>
          ) : (
            <div className={css.tagsContainer}>
              <div style={{ marginBottom: '16px' }}>
                <Button
                  type="link"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleBackToServiceDomains}
                  style={{ padding: 0, marginBottom: '8px' }}
                >
                  Back
                </Button>
                <h4 style={{ marginBottom: '8px' }}>{getSelectedDomainLabel()}</h4>
                <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>Select a Technology:</p>
              </div>
              <div className={css.tagsWrapper}>
                {getTechnologies(selectedServiceDomain).map((tech, index) => (
                  <Tag
                    key={index}
                    color="green"
                    className={css.technologyTag}
                    onClick={() => handleTechnologyClick(tech)}
                    style={{ cursor: 'pointer', margin: '8px', padding: '8px 12px', fontSize: '14px' }}
                  >
                    {tech}
                  </Tag>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const RPFs = (props) => {
  const { redirectToSearchPage } = props;

  const [selectedServiceDomain, setSelectedServiceDomain] = useState(null);

  // Get service domains from fieldOptions
  const serviceDomains = fieldOptions.serviceDomainsOptions || [];

  // Get technologies for the selected service domain
  const getTechnologies = (domainKey) => {
    return fieldOptions.serviceDomainTechnologyMapping[domainKey] || [];
  };

  const handleServiceDomainClick = (domainKey) => {
    setSelectedServiceDomain(domainKey);
  };

  const handleTechnologyClick = (technology) => {
    // Redirect to search page with the technology as filter
    redirectToSearchPage('rfp_listing', technology);
  };

  const handleBackToServiceDomains = () => {
    setSelectedServiceDomain(null);
  };

  // Get selected service domain label
  const getSelectedDomainLabel = () => {
    const domain = serviceDomains.find(d => d.key === selectedServiceDomain);
    // return domain ? domain.subdomain : '';
    return domain ? domain.label : '';
  };

  return (
    <>
      <div className={css.tabContent}>
        <div className={css.tabHeading}>
          <h3>RFPs</h3>
        </div>
        <div className={css.cardScroll}>
          {!selectedServiceDomain ? (
            <div className={css.tagsContainer}>
              <h4>Select a Service Domain:</h4>
              <div className={css.tagsWrapper}>
                {serviceDomains.map(domain => (
                  domain?.subdomain && (
                    <Tag
                      key={domain.key}
                      color="blue"
                      className={css.serviceTag}
                      onClick={() => handleServiceDomainClick(domain.key)}
                      style={{ cursor: 'pointer', margin: '8px', padding: '8px 12px', fontSize: '14px' }}
                    >
                      {/* {domain.subdomain} */}
                      {domain.label}
                    </Tag>
                  )
                ))}
              </div>
            </div>
          ) : (
            <div className={css.tagsContainer}>
              <div style={{ marginBottom: '16px' }}>
                <Button
                  type="link"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleBackToServiceDomains}
                  style={{ padding: 0, marginBottom: '8px' }}
                >
                  Back
                </Button>
                <h4 style={{ marginBottom: '8px' }}>{getSelectedDomainLabel()}</h4>
                <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>Select a Technology:</p>
              </div>
              <div className={css.tagsWrapper}>
                {getTechnologies(selectedServiceDomain).map((tech, index) => (
                  <Tag
                    key={index}
                    color="green"
                    className={css.technologyTag}
                    onClick={() => handleTechnologyClick(tech)}
                    style={{ cursor: 'pointer', margin: '8px', padding: '8px 12px', fontSize: '14px' }}
                  >
                    {tech}
                  </Tag>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};



function SectionChoice(props) {
  const { history, routeConfiguration } = props;

  const redirectToSearchPage = (listingType, technology) => {
    const queryParams = {
      pub_listingType: listingType
    };

    if (technology) {
      queryParams.technology = technology;
    }

    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, queryParams));
  };

  const items = [
    {
      key: '1',
      label: (
        <span>
          <img src={TalentImg} alt="Talent" width={30} />
          Talent
        </span>
      ),
      children: <Talent redirectToSearchPage={redirectToSearchPage} />,
    },
    {
      key: '2',
      label: (
        <span>
          <img src={WorkImg} alt="Work" width={30} />
          Work
        </span>
      ),
      children: <Work redirectToSearchPage={redirectToSearchPage} />,
    },
    {
      key: '3',
      label: (
        <span>
          <img src={PartnersImg} alt="Suppliers" width={30} />
          Suppliers
        </span>
      ),
      children: <Partners redirectToSearchPage={redirectToSearchPage} />,
    },
    {
      key: '4',
      label: (
        <span>
          <img src={RPFsImg} alt="RFPs" width={30} />
          RFPs
        </span>
      ),
      children: <RPFs redirectToSearchPage={redirectToSearchPage} />,
    },
  ];

  return (
    <div className={css.choiceSection}>
      <div className={css.fixedWidthContainer}>
        <h2>Select the right choice for you.</h2>
        <div className={css.verticalTab}>
          <div className={css.inDesktop}><Tabs defaultActiveKey="1" items={items} tabPosition="left" /></div>
          <div className={css.inMobile}><Collapse items={items} /></div>
        </div>
      </div>
    </div>
  );
}

export default SectionChoice;
